var map;
var InfoObj = [];

var icons = {
  adoc:{
    icon: 'https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909'
  }
};

var markersOnMap = [
    {
      storecode: "PAA01",
      placeName: "ADOC Albrook",
      storeAddress:"Centro Comercial Albrook Mall Pasillo el Pingüino, Locales 27D y 27E Marginal, Avenida Roosevelt, Panamá",
      schedule: "Lunes a Sábado: 10:00am a 8:00pm<br>Domingo: 11:00am a 7:00pm",
      phone: "61941196",
      whatsapp: "61941196",
      page: "",
      review: "",
      zona: 1,
      LatLng: [
        {
          lat: 8.97439735881323,
          lng: -79.55252562038636,
        },
      ],
      type: "adoc",
    },
    {
      storecode: "PAA02",
      placeName: "ADOC Metromall",
      storeAddress: "Rufina Alfaro, distrito de San Miguelito, Panama, Avenida Domingo Díaz local # B-166 Y B-167, nivel 100",
      schedule: "Lunes a Sábado: 10:00am a 8:00pm<br>Domingo: 11:00am a 8:00pm",
      phone: "61941196",
      whatsapp: "61941196",
      page: "",
      review: "",
      zona: 1,
      LatLng: [
        {
          lat: 9.052512764119935,
          lng: -79.45051026141043,
        },
      ],
      type: "adoc",
    },
  ]; 

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (507)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width: 4%">(507)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(507)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(507)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(507)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+507'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%"> (507)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=507'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="PAR2 Guatemala" style="width:  4%">(507)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="PAR2 Guatemala" style="width: 4%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 15.7715634, lng: -86.7914299};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 16,
    center: {lat: 15.7715634, lng: -86.7914299},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}